import { ReactComponent as SpinnerIcon } from 'assets/images/spinner.svg?react';
import styles from './Spinner.module.scss';

const Spinner = () => {
  return <SpinnerIcon className={styles.spinner} />;
};

export default Spinner;
